import styled from "styled-components";
import { COLOR } from "src/service/constant/color";
import { customMedia } from "src/styles/common/common";

const RefundWrap = styled.div`
  width: 600px;
  min-width: 328px;
  margin: 86px auto 204px auto;
  display: block;
  ${customMedia.lessThan("tablet")`
      max-width: 600px;
      width: 100%;
      margin: 0 auto 119px auto;
    `
  }
  ${customMedia.lessThan("mobile")`
    margin: 0 0 150px 0;
    `
  }

`;
const  RefundTerms = styled.div`
  display: flex;
  font-family: NotoSansRegular, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 26px;
  padding-bottom: 5px;

  > p {
    white-space: pre-line;
    color: ${COLOR.black};
    margin: 0;

    > span {
      padding-left: 10px;
      cursor: pointer;
      text-decoration-line: underline;
    }
  }

  > img {
    cursor: pointer;
    display: flex;
    width: 26px;
    height: 26px;
  }

  ${customMedia.lessThan("tablet")`
    font-size: 12px;
    max-width: 500px;
    width:100%;
    display: flex;
    line-height: 17px;
    justify-content: unset;
    margin: 0 0 56px 0;
    padding:0;
    > img {
      margin: 0;
      width: 20px;
      height: 20px;
  }
  
 `}

  ${customMedia.lessThan("mobile")`
    margin: 0 0 52px 0;
 `}
`;

const RefundCaution = styled.div`
  display: flex;
  justify-content: center;

  margin-top: 50px;

  text-align: center;
  font-family: NotoSansRegular, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  color: ${COLOR.point1};

  ${customMedia.lessThan("tablet")`
    font-size: 12px;
    line-height: 17px;
    margin: 30px 0 56px 0;
    padding: 0;
 `}

  ${customMedia.lessThan("mobile")`
 `}
`;

const  SubScriptTitle = styled.h3`
  font-size: 24px;
  line-height: 35px;
  font-family: NotoSansBold, sans-serif;
  white-space: pre-line;
  margin: 70px 0 12px 0;
  color: ${COLOR.black};
  ${customMedia.lessThan('tablet')`
      margin: 50px 0 8px 0;
      font-size: 16px;
      line-height: 23px;
  `}
  
  ${customMedia.lessThan("mobile")`
    margin: 40px 0 8px 0;
  `}
`
const SubScriptDesc = styled.div`
  margin: 12px 0 25px 0;

  color: ${COLOR.gray50};
  > p {
    white-space: pre-line;
    line-height: 20px;
    font-size: 14px;
    font-family: NotoSansRegular, sans-serif;
    color: ${COLOR.gray50};
  }
  .warning {
    color: ${COLOR.point1};
  }

  ${customMedia.lessThan("tablet")`
    margin: 0 0 54px 0;
    max-width: 600px;
    width: 100%;
    >p{
     font-size: 12px;
     line-height: 17px;   
    }
  `}

  ${customMedia.lessThan("mobile")`
    margin: 0 0 40px 0;
  `}
`;
export { RefundWrap, RefundTerms, RefundCaution, SubScriptTitle, SubScriptDesc };
